<template>
    <div class="body">
        <div class="title">
            <van-nav-bar title="活动余额列表" fixed  left-arrow @click-left="onClickLeft"/>
        </div>
        <div class="u-scroll">
            <div class="text9">可使用活动余额</div>
            <div class="item1" v-for="item in dataList"  :key="item.id">
                <div class="item-top">
                    <img src="@/assets/hd/down1.png" alt="">
                    <div class="text1">{{item.name}}</div>
                    <div class="text2">￥</div>
                    <div class="text3">{{item.price}}</div>
                </div>
                <div class="item-center">
                    <div class="text4">{{item.create_time}}</div>
                </div>
                <div class="text5">{{item.note}}</div>
                <div class="choose">
                    <van-checkbox v-if="item.types === 0 && !item.disabled" v-model="item.checked"  @change="checkChange(item)"></van-checkbox> 
                    <van-checkbox v-if="item.types === 1 && !item.disabled" v-model="item.checked"  @change="checkChange1(item)"></van-checkbox> 
                </div>
            </div>
            <template v-if="dataList1.length > 0">
                <div class="text9">不可使用活动余额</div>
                <div class="item1 item1-a"  v-for="item in dataList1" :key="item.id">
                    <div class="item-top">
                        <img src="@/assets/hd/down1.png" alt="">
                        <div class="text1">{{item.name}}</div>
                        <div class="text2">￥</div>
                        <div class="text3">{{item.price}}</div>
                    </div>
                    <div class="item-center">
                        <div class="text4">{{item.create_time}}</div>
                    </div>
                    <div class="text5">{{item.note}}</div>
                </div>
            </template>
            
        </div>
        <div class="bottom">
            <div class="text11">优惠券优惠：</div>
            <div class="text12">￥</div>
            <div class="text13">{{total}}</div>
            <van-button class="btn1" type="primary" @click="cofrim">确认</van-button>
        </div>
    </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant';
export default {
    data(){
        return{
            dataListCopy:[],
            dataList:[],
            dataList1:[],
            primaryId:'',
            secondaryId:'',
            dataForm:{},
            path:"",
            total:0,
        }
    },
    created(){
        this.dataForm = JSON.parse(decodeURIComponent(this.$route.query.params))
        this.infoData()
    },
    beforeRouteEnter(form,to,next){
        next(vm => {
            vm.path = to.path
        })
    },
    methods:{
        //初始化数据
        infoData(){
            this.total = 0
            this.dataList=[]
            this.dataListCopy=[]
            wxRequest('/applyChangeSim/show/salePrice', {iccid: this.$store.state.iccid}, 'post').then(res => {
			    if(res.data.code == 200){
                    res.data.data.forEach(item=>{
                        if(item.state === 0){
                            item.checked = false
                            item.disabled = false
                            this.dataList.push(item)
                            this.dataListCopy.push(item)
                        }
                    })
			    }else {
			        Toast.fail(res.data.message);
			    }
			})
        },
        //主卷
        checkChange(data){
            this.primaryId = ''
            if(data.checked ){
                this.primaryId = data.id
                this.total += data.price * 1
            }else{
                this.total -= data.price * 1
            }
            this.dataListCopy.forEach(item=>{
                if(data.id !== item.id && 0 === item.types ){
                    item.checked = false
                    item.disabled = false
                    if(data.checked ){
                        item.disabled = true
                    }
                }
            })
            this.dataList1=this.dataListCopy.filter(item=> item.disabled)
            this.dataList=this.dataListCopy.filter(item=> !item.disabled)
        },
        //叠加卷
        checkChange1(data){
            this.secondaryId = ''
            if(data.checked ){
                this.secondaryId = data.id
                this.total += data.price * 1
            }else{
                this.total -= data.price * 1
            }
            this.dataListCopy.forEach(item=>{
                if(data.id !== item.id && 1 === item.types ){
                    item.checked = false
                    item.disabled = false
                    if(data.checked){
                        item.disabled = true
                    }
                }
            })
            this.dataList1=this.dataListCopy.filter(item=> item.disabled)
            this.dataList=this.dataListCopy.filter(item=> !item.disabled)
        },
        onClickLeft(){
            var params = {
                ...this.dataForm,
                price:this.total,
                secondaryId:this.secondaryId,
                primaryId:this.primaryId
            }
            this.$router.push({path:this.path, query: {params: encodeURIComponent(JSON.stringify(params))}});
        },
        cofrim(){
            var params = {
                ...this.dataForm,
                price:this.total,
                secondaryId:this.secondaryId,
                primaryId:this.primaryId
            }
            this.$router.push({path: this.path, query: {params: encodeURIComponent(JSON.stringify(params))}});
        }
    }
}
</script>
<style lang="less" scoped>
.body{
    width:100%;
    // height:100vh;
    .title{
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 46px;
        background-color: rgb(255, 255, 255);
    }
    .u-scroll{
        background:#f7f8fa;
        padding:0 14px;
        height: calc(100% - 116px);
        padding-bottom:70px;
        .text9{
            font-size: 17px;
            font-weight: 700;
            color: #06121e;
            align-self: center;
            width: 340px;
            padding: 16px 0 14px;
        }
        .item1-a{
            opacity: .5;
        }
        .item1{
            padding: 18px 16px;
            border-radius: 16px;
            background-color: #fff;
            margin-bottom: 14px;
            position: relative;
            .item-top{
                flex-direction: row;
                align-items: center;
                margin-right: 45px;
                 display: flex;
                img{
                    width:16px;
                    height:24px;
                }
                .text1{
                    font-size: 17px;
                    font-weight: 700;
                    color: #06121e;
                    flex: 1;
                    margin-left: 9px;
                }
                .text2{
                    font-size: 24px;
                    font-weight: 500;
                    color: #ff5656;
                }
                .text3{
                    font-size: 34px;
                    font-weight: 500;
                    color: #ff5656;
                }
            }
            .item-center{
                flex-direction: row;
                justify-content: space-between;
                border-bottom: 1px solid #eee;
                padding-bottom: 13px;
                display: flex;
                .text4{
                    font-size: 14px;
                    color: #3d444d;
                    margin-top: 5px;
                }
            }
            .text5{
                font-size: 12px;
                color: #3d444d;
                margin-top: 10px;
            }
            .choose{
                width: 16px;
                height: 16px;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 20px;
                right: 20px;
                ::v-deep .van-checkbox__icon {
                    .van-icon{
                        font-size: 12px;
                        width: 16px;
                        height: 16px;
                        line-height: 15px;
                    }
                }
            }
        }
    }
    .bottom{
        position: fixed;
        bottom: 0;
        left: 0;
        height: 70px;
        background-color: #fff;
        flex-direction: row;
        align-items: center;
        display: flex;
        width:100%;
        .text11{
            font-size: 12px;
            color: #3d444d;
            margin-bottom: 10px;
            padding-left:20px;
        }
        .text12{
            font-size: 12px;
            color: #ff5656;
            margin-bottom: 10px;
        }
        .text13{
            font-size: 28px;
            font-weight: 500;
            color: #ff5656;
            line-height: 26px;
            margin-bottom: 10px;
            flex: 1;
        }
        .btn1{
            width: 135px;
            height: 50px;
            border-radius: 25px;
            border: 0;
            line-height: 50px;
            margin-right:40px;
            background: #3476fe;
            color: #fff;
            text-align: center;
        }
    }
}
</style>